<template>
  <div
    class="image-btn"
    :style="{
      width: width,
      height: height,
      backgroundImage: isHover ? `url(${hoverBgImage})` : `url(${bgImage})`,
    }"
    @mouseover="isHover = true"
    @mouseleave="isHover = false"
  >
    <span class="btn-text" :style="{ fontSize: fontSize }">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "ImageButton",
  props: {
    text: {
      type: String,
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    fontSize: {
      type: String,
      default: "2rem",
    },
    bgImage: {
      type: String,
      required: true,
    },
    hoverBgImage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isHover: false,
    };
  },
  created() {},
  methods: {},
};
</script>

<style>
.image-btn {
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex; /* 使用flex布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
.btn-text {
  text-align: center;
  color: #fff;
  text-shadow: #000 0px 0px 4px;
}
</style>
